$(document).ready(function() {
  $(document).on('submit', '.grid-product__form', function(e) {
    e.preventDefault();
    var $form = $(this);
    var $button = $form.find('button[type="submit"]');

    if ($button.hasClass('btn--loading')) {
      return;
    }

    $button.addClass('btn--loading');

    var data = $form.serialize();

    if (window.theme && theme.cart && typeof theme.cart.addItemFromForm === 'function') {
      theme.cart.addItemFromForm(data)
        .then(function(product) {
          $('body').trigger('added.ajaxProduct', $button);
        })
        .catch(function(error) {
          console.error('Error adding to cart:', error);
          // Fallback to standard submission if AJAX fails
          $form.off('submit').submit();
        })
        .always(function() {
          $button.removeClass('btn--loading');
        });
    } else {
      // Fallback if theme AJAX cart is not available
      $form.off('submit').submit();
    }
  });
});
